<mat-form-field [style.width]="width">
  <mat-label class="font-semibold" *ngIf="label">
    {{ label | translate }}
    <small *ngIf="required" class="text-gray-400"
      >({{ 'shared:required' | translate }})</small
    >
  </mat-label>
  <mat-select
    [(ngModel)]="currency"
    (ngModelChange)="valueChanged.next(currency)"
    [required]="required">
    <mat-select-trigger>
      <mat-progress-spinner
        class="ml-2"
        [diameter]="24"
        [mode]="'indeterminate'"
        *ngIf="loading"></mat-progress-spinner>

      <div class="flex items-center" *ngIf="!loading && currency">
        <img
          class="object-cover w-6 h-6 rounded-full mr-2"
          *ngIf="currency.currencyIso"
          src="https://flagcdn.com/{{
            currency.currencyIso | currencyCountry
          }}.svg"
          [alt]="currency.currencyIso"
          width="36"
          height="27" />
        <span *ngIf="currency.currencyIso">{{ currency.currencyIso }}</span>
        <span *ngIf="!currency.currencyIso">{{
          'currencyName:ALL' | translate
        }}</span>
      </div>
    </mat-select-trigger>

    <mat-option [value]="empty" *ngIf="emptyOption">
      <div class="flex items-center">{{ 'currencyName:ALL' | translate }}</div>
    </mat-option>
    <mat-option [value]="item" *ngFor="let item of currencies">
      <div class="flex items-center">
        <img
          class="object-cover w-6 h-6 rounded-full mr-2"
          src="https://flagcdn.com/{{ item.currencyIso | currencyCountry }}.svg"
          [alt]="item.currencyIso"
          width="36"
          height="27" />
        {{ item.currencyIso }}
      </div>
    </mat-option>
  </mat-select>
</mat-form-field>
